
import BattlecardToolbar from './_battlecard_toolbar';
import BattlecardView from './_battlecard_view';

import {userCanCurate} from '../modules/roles_utils';
import {refreshDynamicContent} from '../modules/card_utils';
import {analyticsTrack, SNOWPLOW_SCHEMAS, pageTrackingTypes} from '../modules/analytics_utils';
import {dig} from '../modules/utils';
import {uiViewports, BATTLE_CARD_LAYOUT} from '../modules/constants/ui';

import Fullscreen from 'react-full-screen';
import classNames from 'classnames';
import {withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import {compose} from 'redux';

class Battlecard extends React.Component {

  static contextTypes = {
    api: PropTypes.object.isRequired,
    utils: PropTypes.object.isRequired
  };

  static propTypes = {
    company: PropTypes.object,
    users: PropTypes.objectOf(PropTypes.object),
    maxBattlecardCards: PropTypes.number,
    embedMode: PropTypes.bool,
    onTrackRecentProfileView: PropTypes.func,
    history: PropTypes.object,
    location: PropTypes.object
  };

  static defaultProps = {
    company: null,
    users: {},
    maxBattlecardCards: 0,
    embedMode: false,
    onTrackRecentProfileView() {},
    history: {},
    location: {}
  };

  state = {
    fullscreen: false,
    layout: BATTLE_CARD_LAYOUT.single,
    focusedCard: null,
    setDefaultSuccess: false
  };

  componentDidMount() {
    console.log('Battlecard.componentDidMount: props: %o', this.props);

    const {onTrackRecentProfileView} = this.props;
    const {rival, battlecard} = this.context.utils;
    const {profile = {}} = rival || {};

    if(!_.isEmpty(profile)) {
      const {id: profileId, curatorsCount, curators} = profile;

      // track recent profile view
      onTrackRecentProfileView(profileId);

      if(curatorsCount) {
        // queue up requests for profile curators
        this.requestProfileCurators(curators);
      }

      this.analyticsTrack(rival, battlecard);
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps, nextContext) {
    const {rival: nextRival, battlecard: nextBattlecard} = nextContext.utils;
    const {profile = {}} = nextRival || {};
    const {battlecard} = this.context.utils;
    let battlecardId;
    let battlecardLayout;

    if(!_.isEmpty(profile)) {
      const {id, curators, curatorsCount} = profile;

      if(id) {
        // track recent profile view
        this.props.onTrackRecentProfileView(id);
      }

      if(nextBattlecard && (!battlecard || (battlecard.id !== nextBattlecard.id))) {
        if(curatorsCount) {
          // queue up requests for profile curators
          this.requestProfileCurators(curators);
        }

        this.analyticsTrack(nextRival, nextBattlecard);

        battlecardId = nextBattlecard.id;
        battlecardLayout = nextBattlecard.layout;

        this.setState({focusedCard: null});
      }
      else if(nextBattlecard) {
        battlecardId = battlecard.id;
        battlecardLayout = battlecard.layout;
      }

      const userLayoutPrefs = dig(this.context.utils, 'user.userData.battlecardLayouts', {});
      let layout;

      if(userLayoutPrefs[battlecardId]) {
        layout = userLayoutPrefs[battlecardId];
      }
      else {
        layout = battlecardLayout || BATTLE_CARD_LAYOUT.single;
      }

      this.setState({
        layout,
        setDefaultSuccess: false
      });
    }
  }

  componentDidUpdate() {
    refreshDynamicContent();
  }

  _getProfile = () => {
    const {profile = {}} = this.context.utils.rival || {};

    return profile;
  };

  analyticsTrack = (rival = {}, battlecard = {}) => {
    if(_.isEmpty(rival) || _.isEmpty(battlecard)) {
      return;
    }

    const {id: battlecardId = null} = battlecard;
    const trackingData = {};

    const battlecardTitle = battlecard.title || '(Untitled Battlecard)';
    const windowWidth = window.innerWidth || Infinity;    // window.innerWidth ie9+ support
    const view = (windowWidth <= 600) ? uiViewports.MOBILE : (windowWidth <= 1279) ? uiViewports.TABLET : uiViewports.DESKTOP;
    const cardCount = (battlecard.cards && battlecard.cards[view].filter(card => card !== '').length) || 0;

    if(battlecardId) {
      const {id: rivalId, profile: {isDraft}} = rival;

      trackingData.context = [
        {
          schema: SNOWPLOW_SCHEMAS.battleCard,
          data: {id: battlecardId}
        },
        {
          schema: SNOWPLOW_SCHEMAS.board,
          data: {
            id: rivalId,
            status: isDraft ? 'draft' : 'published'
          }
        }
      ];
    }

    const {href: currentLocation} = location;
    let event;

    pageTrackingTypes.forEach(type => {
      if(type === 'event') {
        event = {
          type,
          category: 'Battlecard',
          action: 'view',
          label: `${rival.name}: ${battlecardTitle}`,
          value: cardCount
        };
      }
      else {
        event = {
          path: `${currentLocation}`,
          type
        };
      }

      analyticsTrack(event, trackingData);
    });
  };

  requestProfileCurators = (curators = []) => {
    if(_.isEmpty(curators)) {
      return;
    }

    curators.forEach(userId => this.context.utils.requestUser({userId}));
  };

  handleFocusCard = (card = null) => this.setState({focusedCard: card}, refreshDynamicContent);

  handleFullscreenClick = () => this.setState(prevState => ({fullscreen: !prevState.fullscreen}));

  handleLayoutSelect = val => {
    this.setState({
      layout: val
    });

    const {user = {}, battlecard = {id: -1}} = this.context.utils;
    const {userData = {}} = user;
    const battlecardId = battlecard.id;

    if(!userData.battlecardLayouts) {
      userData.battlecardLayouts = {};
    }

    userData.battlecardLayouts[battlecardId] = val;

    const newUserData = {
      id: user.id,
      userData
    };

    this.context.api.userUpdate(newUserData).then(() => {
      this.setState({setDefaultSuccess: false});

      refreshDynamicContent();
    });
  };

  handleSetDefaultLayout = () => {
    const {id, profile} = this.context.utils.battlecard;

    this.context.api.battlecardCreateOrUpdate({
      id,
      profileId: profile.id,
      layout: this.state.layout
    }, () => this.setState({setDefaultSuccess: true}));
  };

  render() {
    const profile = this._getProfile() || {};
    const {embedMode, users, company, maxBattlecardCards} = this.props;
    const {fullscreen, layout, focusedCard, setDefaultSuccess} = this.state;
    const {user} = this.context.utils;
    let battlecardToolbarRegion;

    if(_.isEmpty(profile)) {
      return null;
    }

    if(!embedMode && !fullscreen && (profile.battlecardsCount || userCanCurate({user}))) {
      battlecardToolbarRegion = (
        <div className="battlecard-section_toolbar">
          <BattlecardToolbar
            users={users}
            onFullscreenClick={this.handleFullscreenClick}
            onSelectLayout={this.handleLayoutSelect}
            onSetDefaultLayout={this.handleSetDefaultLayout}
            setDefaultSuccess={setDefaultSuccess} />
        </div>
      );
    }

    const battlecardSectionClasses = classNames('battlecard-section', {
      'battlecard-section--fullscreen': fullscreen
    });

    return (
      <div className={battlecardSectionClasses} data-print-heading={profile.name}>
        {battlecardToolbarRegion}
        <Fullscreen
          enabled={fullscreen}
          onChange={fs => this.setState({fullscreen: fs})}>
          <div className="battlecard-section_cards">
            <BattlecardView
              companyLastUpdated={company && company.updatedAt}
              maxBattlecardCards={maxBattlecardCards}
              showPreviewLinkOnCards={true}
              layout={layout}
              onFocusCard={this.handleFocusCard}
              focusedCard={focusedCard} />
          </div>
        </Fullscreen>
      </div>
    );
  }

}

const mapDispatchToProps = dispatch => ({
  loadOrFetchRivals: () => dispatch.rivals.loadOrFetchRivals()
});

const enhance = compose(
  connect(null, mapDispatchToProps),
  withRouter
);

export default enhance(Battlecard);
